import { sources } from '../data/sources';
import { curatedModels } from '../data/models';
import { chips, computeProviders, modelPlatforms } from '../data/stack';

export const OPENROUTER_API = 'https://openrouter.ai/api/v1/models';
import { Source } from '../types/census';

export interface IndexedSource {
  n: number;
  id: string | null;
  name: string;
  url: string;
  publisher: string;
  kind: Source['kind'];
}

export function hostOf(url: string): string {
  if (url.startsWith('/')) return 'agent-census';
  try {
    return new URL(url).hostname.replace(/^www\./, '');
  } catch {
    return url;
  }
}

const list: IndexedSource[] = [];
const byUrl = new Map<string, IndexedSource>();
const byId = new Map<string, IndexedSource>();

function add(id: string | null, name: string, url: string, publisher: string, kind: Source['kind']) {
  const existing = byUrl.get(url);
  if (existing) {
    if (id) byId.set(id, existing);
    return;
  }
  const entry: IndexedSource = { n: list.length + 1, id, name, url, publisher, kind };
  list.push(entry);
  byUrl.set(url, entry);
  if (id) byId.set(id, entry);
}

sources.forEach((s) => add(s.id, s.name, s.url, s.publisher, s.kind));
curatedModels.forEach((m) => add(null, `${m.model} — ${m.lab} announcement`, m.sourceUrl, hostOf(m.sourceUrl), 'official'));
modelPlatforms.forEach((p) => add(null, `${p.name} — models & pricing`, p.sourceUrl, hostOf(p.sourceUrl), 'official'));
computeProviders.forEach((c) => {
  add(null, `${c.name} — GPU offering & pricing`, c.sourceUrl, hostOf(c.sourceUrl), 'official');
  if (c.scaleSourceUrl) add(null, `${c.name} — scale disclosure (filing)`, c.scaleSourceUrl, hostOf(c.scaleSourceUrl), 'official');
});
chips.forEach((c) => add(null, `${c.maker} ${c.name} — vendor specifications`, c.sourceUrl, hostOf(c.sourceUrl), 'official'));
add(null, 'OpenRouter models API', OPENROUTER_API, 'openrouter.ai', 'api');

export const sourceIndex: IndexedSource[] = list;

export function getSourceById(id: string): IndexedSource | undefined {
  return byId.get(id);
}

export function lookupByUrl(url: string): IndexedSource | undefined {
  return byUrl.get(url);
}
